import { gql } from '@apollo/client'

// FIXME: this should be generated by apollo
export interface IFoodListFragmentType {
  itemName: string
  category: string
  popularity: number
  portionContributionMargin: number
  totalContributionMargin: string
  contributionMarginPercent: number
  theoreticalCostPerUnit: string
  itemSales: string
  percentOfSales: string
}

export const foodListFragment = gql`
  fragment foodListFragment on ListLocationMenuItemsRecord {
    itemName
    category
    popularity
    portionContributionMargin
    totalContributionMargin
    contributionMarginPercent
    theoreticalCostPerUnit
    itemSales
    percentOfSales
  }
`
